<template>
  <div class="policy-list">
    <div class="policy-items">
      <div v-for="(item, index) in helpItems" :key="item.id" :style="getStyle(index)" class="policy-item"
        @click="goToProtocol(item.id)">
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ProtocolListData from "../assets/ProtocolListData.json";

export default {
  name: "ProtocolList",
  data() {
    return {
      helpItems: ProtocolListData,
    };
  },
  methods: {
    goToProtocol(id) {
      if (id === 1) {
        this.$router.push({ name: "PolicyPage" })
      } else if (id === 2) {
        this.$router.push({ name: "UserPage" })
      }
    },
    getStyle(index) {
      // 判断是否是奇数
      if (index % 2 === 0) {
        return {
          borderRadius: " 0 16px 16px 16px",
        };
      }
      return {
        borderRadius: "16px 0 16px 16px",
      };
    },
  },
};
</script>

<style scoped>
.policy-list {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 16px 16px 20px;
  background-color: transparent;
  font-family: "Montserrat", sans-serif;
}

.policy-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.policy-item {
  padding: 20px 16px;
  border-radius: 16px 16px 16px 0;

  background-image: url("../assets/item_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
</style>
